import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Team = () => {
  const [activeBio, setActiveBio] = useState(null);

  const advisors = [
    {
      id: 'qazi',
      name: 'Qazi Ali',
      position: 'Medical Student',
      image: '/assets/team/qazi.jpg'
    },
    {
      id: 'abdulah',
      name: 'Abdulah Hafeez',
      position: 'Physician Assistant Student',
      image: '/assets/team/abdulah.jpg'
    },
    {
      id: 'aloshy',
      name: 'Aloshy Denny',
      position: 'Medical Student',
      image: '/assets/team/aloshy.jpg'
    }
  ];

  const healthcareProfessionals = [
    {
      id: 'amira',
      name: 'Amira Murtazaeva',
      position: 'Orthopedic Physical Therapist',
      image: '/assets/team/amira.png',
      bio: "Hi! I'm Amira, a NYC-based orthopedic physical therapist focused on movement-based care and longevity. I'm passionate about mentorship and community building, with an interest in shaping how people engage with health, movement and sustainable wellness. I aim to contribute to conversations that elevate how care is understood and delivered. Outside of work, I enjoy lifting, reading, cooking, and staying active."
    }
  ];

  const teamMembers = [
    {
      id: 'doston',
      name: 'Doston Karimov',
      position: 'Founder and President',
      image: '/assets/team/doston.JPG',
      bio: 'Biochemistry major at Hunter College interested in community health and building spaces where students can learn and grow together. I enjoy spending my free time cooking or running.'
    },
    {
      id: 'zeeshan',
      name: 'Zeeshan Gondal',
      position: 'Vice President',
      image: '/assets/team/zeeshan.JPG',
      bio: "Hello, I'm Zeeshan, a senior in CS with a minor in math at Hunter College. I am an aspiring Software Engineer.",
      linkedin: 'https://www.linkedin.com/in/zeeshan-gondal/'
    },
    {
      id: 'yulduz',
      name: 'Yulduz Mardonova',
      position: 'Treasurer',
      image: '/assets/team/yulduz.JPG',
      bio: "I'm an Economics major and pre-law student at Hunter College, and I work as a paralegal at a personal injury law firm. I'm drawn to work that supports people and communities. In my free time, I enjoy baking, going on walks, painting, and crocheting."
    },
    {
      id: 'marjona',
      name: 'Marjona Burhanova',
      position: 'Secretary',
      image: '/assets/team/marjona.JPG',
      bio: "Hey, my name is Marjona, and I'm a Nursing major passionate about healthcare and community outreach. My hobbies include biking, spending time with friends/family, and I'm a big music person"
    },
    {
      id: 'crystal',
      name: 'Crystal Huang',
      position: 'Community Engagement Lead',
      image: '/assets/team/crystal.JPG',
      bio: "Hi, my name is Crystal, and I'm currently a Human Biology major aiming to become a cosmetic dermatologist. I love beauty, skin, and am passionate about health education, confidence, and my ultimate goal is to help people feel comfortable in their own skin!"
    },
    {
      id: 'mubina',
      name: 'Mubinakhon Munirkhonova',
      position: 'Content & Community Lead',
      image: '/assets/team/mubina.JPG',
      bio: "Hey everyone, my name is Mubinakhon, and I'm a bio major on the pre-med route at Hunter College. I'm very passionate about going into medicine and helping others.",
      linkedin: 'https://linkedin.com/in/mubinakhon-munirkhonova'
    },
    {
      id: 'shakhzoda',
      name: 'Shakhzoda Shakarova',
      position: 'Content & Community Lead',
      image: '/assets/team/shakhzoda.JPG',
      bio: "Hey, my name is Shakhzoda, and I'm a pre-nursing major at Hunter College. I'm passionate about caring for others to support our community. In my free time, I enjoy reading and spending time with my friends and family!",
      linkedin: 'https://linkedin.com/in/shakhzoda-shakarova'
    },

    {
      id: 'diyora',
      name: 'Diyora Nigmanova',
      position: 'Content & Community Lead',
      image: '/assets/team/diyora.JPG',
      bio: 'Hello, my name is Diyora. I am an undergraduate biology major at Hunter College with aspirations of pursuing a career in medicine. Outside of academics, I enjoy baking, reading, engaging in sports and video games, and spending time with my friends and family. My overarching goal is to contribute meaningfully to my community and improve the well-being of those around me.',
      linkedin: 'https://www.linkedin.com/in/diyora-nigmanova'
    },
    {
      id: 'silvia',
      name: 'Silvia Hanna',
      position: 'Content & Community Lead',
      image: '/assets/team/silvia.jpg',
      bio: 'Hello everyone! I am a Hunter student in my final semester, majoring in biology. I am particularly interested in the intersection between STEM (especially medicine) and the humanities. In my free time, I like to craft (jewelry-making, crochet, etc.), read, cook, and spend time with my younger siblings.'
    },
    {
      id: 'alexander',
      name: 'Alexander Bezborodov',
      position: 'Outreach & Community Engagement Committee',
      image: '/assets/team/alexander.jpg',
      bio: 'Salutations, everyone! My name is Alexander Bezborodov, and I am a biology undergraduate major at Hunter College. My current aspirations focus on becoming an oral and maxillofacial surgeon. In my free time, I work out and take care of my puppy. I also enjoy watching movies and reading fantasy novels.',
      linkedin: 'https://linkedin.com/in/alexander-bezborodov'
    },
    {
      id: 'shakhrizoda',
      name: 'Shakhrizoda Kabilova',
      position: 'Research and Accuracy Lead',
      image: '/assets/team/shakhrizoda.JPG',
      bio: 'Human Biology major at Hunter College on a pre-med track. In my free time, I like to read and hang out with friends and family. I am interested in giving back to my community and helping others.'
    },
    {
      id: 'nuriddin',
      name: 'Nuriddin Fazliddinov',
      position: 'Research and Accuracy Lead',
      image: '/assets/team/nuriddin.JPG',
      bio: 'Biology undergraduate at Hunter College, certified as an EMT-B, aspiring surgeon who enjoys soccer, reading, biking, and gaming.',
      linkedin: 'https://linkedin.com/in/nuriddin-fazliddinov',
      instagram: 'https://instagram.com/nuriddinft'
    },
    {
      id: 'sapphire',
      name: 'Sapphire Perera',
      position: 'University Ambassador – NYU',
      image: '/assets/team/sapphire.jpg',
      bio: 'Hello everyone! I just graduated from NYU in May 2025 as a Biology major! I\'m from Long Island, but I live on the Upper East Side in NYC. My plans include applying to med schools for the next cycle.'
    },
    {
      id: 'mubina-a',
      name: 'Mubina Abdullaeva',
      position: 'University Ambassador – CCNY',
      image: '/assets/team/mubina-a.jpg',
      bio: 'Hi, my name is Mubina, and I\'m currently a freshman at the City College of New York working towards a Biology degree. I\'m from Brooklyn, and I love baking, drawing, singing, and swimming.'
    },
    {
      id: 'michael',
      name: 'Michael Lana',
      position: 'University Ambassador – CCNY',
      image: '/assets/team/michael.jpg',
      bio: 'Hello, my name is Michael Lana, and I am a Junior Biology student at the City College of New York. I am interested in medicine and am working to become a doctor. In my free time, I like to make double cheeseburgers and produce beats.'
    },
    {
      id: 'ivie',
      name: 'Ivie Li',
      position: 'University Ambassador – NYU',
      image: '/assets/team/ivie.jpg',
      bio: 'Hi! My name is Ivie, and I graduated in May 2025 from NYU as a Nutrition major and am currently doing a post-bacc at Fordham on the PA route. In my free time, I like to bake and dance.'
    }
  ];

  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  // Handle hash-based navigation (for author links from blog)
  useEffect(() => {
    const checkHash = () => {
      const hash = window.location.hash.slice(1); // Remove the #
      if (hash) {
        // Check if hash matches any team member ID
        const allMembers = [...teamMembers, ...advisors, ...healthcareProfessionals];
        const member = allMembers.find(m => m.id === hash);
        if (member) {
          setActiveBio(hash);
          // Scroll to the member card after a brief delay to ensure DOM is ready
          setTimeout(() => {
            const element = document.querySelector(`[data-member-id="${hash}"]`);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }, 300);
        }
      }
    };

    // Check hash on mount
    checkHash();

    // Listen for hash changes
    window.addEventListener('hashchange', checkHash);
    return () => window.removeEventListener('hashchange', checkHash);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>

      <section className="ul-breadcrumb ul-section-spacing">
        <div className="ul-container">
          <h2 className="ul-breadcrumb-title">Meet Our Team</h2>
          <ul className="ul-breadcrumb-nav">
            <li><Link to="/">Home</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li>Our Team</li>
          </ul>
        </div>
      </section>

      <section className="ul-team ul-inner-team ul-section-spacing">
        <div className="ul-container">

          <div className="mb-5">
            <h3
              className="text-center mb-4"
              style={{fontSize: 'clamp(24px, 2.5vw, 32px)', fontWeight: 600}}
            >
              Student Leadership
            </h3>
            <p
              className="text-center mb-5"
              style={{maxWidth: '800px', margin: '0 auto', color: 'var(--ul-p, #666)'}}
            >
              Pathio is built by students from Hunter College, Columbia
              University, and NYC communities who are passionate about public
              health, medical education, design, and community empowerment.
            </p>
            <div
              className="row row-cols-md-4 row-cols-sm-3 row-cols-2 row-cols-xxs-1 ul-team-row justify-content-center gy-4"
            >
              {teamMembers.map((member) => (
                <div key={member.id} className="col" data-member-id={member.id}>
                  <div className={`ul-team-member ${activeBio === member.id ? 'show-bio' : ''}`}>
                    <div className="ul-team-member-front">
                      <div className="ul-team-member-img">
                        <img
                          src={member.image}
                          alt={`${member.name} - ${member.position}`}
                        />
                        {member.linkedin || member.instagram ? (
                          <div className="ul-team-member-socials">
                            {member.linkedin && (
                              <a href={member.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="flaticon-linkedin-big-logo"></i></a>
                            )}
                            {member.instagram && (
                              <a href={member.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="flaticon-instagram"></i></a>
                            )}
                          </div>
                        ) : null}
                        <button 
                          className="ul-team-member-view-bio"
                          onClick={(e) => {
                            e.stopPropagation();
                            setActiveBio(member.id);
                          }}
                        >
                          View Bio
                        </button>
                      </div>
                      <div className="ul-team-member-info">
                        <h3 className="ul-team-member-name">{member.name}</h3>
                        <p className="ul-team-member-designation">{member.position}</p>
                      </div>
                    </div>
                    <div className="ul-team-member-back">
                      <div className="ul-team-member-bio">
                        <div className="ul-team-member-bio-content">
                          <button 
                            className="ul-team-member-back-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              setActiveBio(null);
                            }}
                            aria-label="Back to profile"
                          >
                            <i className="flaticon-left-arrow"></i>
                          </button>
                          <h4 className="ul-team-member-bio-name">{member.name}</h4>
                          <p className="ul-team-member-bio-position">{member.position}</p>
                          <p className="ul-team-member-bio-text">{member.bio}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div
            className="mt-5 pt-5"
            style={{borderTop: '2px solid rgba(0, 0, 0, 0.1)', position: 'relative', zIndex: 1}}
          >
            <h3
              className="text-center"
              style={{
                fontSize: 'clamp(24px, 2.5vw, 32px)', 
                fontWeight: 600,
                marginBottom: 'clamp(35px, 3.5vw, 50px)',
                position: 'relative',
                zIndex: 10
              }}
            >
              Advisors
            </h3>
            
            <div
              className="row row-cols-md-4 row-cols-sm-3 row-cols-2 row-cols-xxs-1 ul-team-row justify-content-center gy-4 advisors-row"
            >
              {advisors.map((advisor) => (
                <div key={advisor.id} className="col" data-member-id={advisor.id}>
                  <div className="ul-team-member ul-team-member-no-bio">
                    <div className="ul-team-member-front">
                      <div className="ul-team-member-img">
                        <img
                          src={advisor.image}
                          alt={`${advisor.name} - ${advisor.position}`}
                        />
                        {advisor.linkedin || advisor.instagram ? (
                          <div className="ul-team-member-socials">
                            {advisor.linkedin && (
                              <a href={advisor.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="flaticon-linkedin-big-logo"></i></a>
                            )}
                            {advisor.instagram && (
                              <a href={advisor.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="flaticon-instagram"></i></a>
                            )}
                          </div>
                        ) : null}
                      </div>
                      <div className="ul-team-member-info">
                        <h3 className="ul-team-member-name">{advisor.name}</h3>
                        <p className="ul-team-member-designation">{advisor.position}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div
            className="mt-5 pt-5"
            style={{borderTop: '2px solid rgba(0, 0, 0, 0.1)', position: 'relative', zIndex: 1}}
          >
            <h3
              className="text-center"
              style={{
                fontSize: 'clamp(24px, 2.5vw, 32px)',
                fontWeight: 600,
                marginBottom: 'clamp(35px, 3.5vw, 50px)',
                position: 'relative',
                zIndex: 10
              }}
            >
              Healthcare Professionals
            </h3>

            <div
              className="row row-cols-md-4 row-cols-sm-3 row-cols-2 row-cols-xxs-1 justify-content-center gy-4"
            >
              {healthcareProfessionals.map((member) => (
                <div
                  key={member.id}
                  className="col mx-auto"
                  data-member-id={member.id}
                  style={{maxWidth: 'clamp(220px, 24vw, 320px)'}}
                >
                  <div className={`ul-team-member ${activeBio === member.id ? 'show-bio' : ''}`}>
                    <div className="ul-team-member-front">
                      <div className="ul-team-member-img">
                        <img
                          src={member.image}
                          alt={`${member.name} - ${member.position}`}
                        />
                        {member.linkedin || member.instagram ? (
                          <div className="ul-team-member-socials">
                            {member.linkedin && (
                              <a href={member.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="flaticon-linkedin-big-logo"></i></a>
                            )}
                            {member.instagram && (
                              <a href={member.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="flaticon-instagram"></i></a>
                            )}
                          </div>
                        ) : null}
                        <button
                          className="ul-team-member-view-bio"
                          onClick={(e) => {
                            e.stopPropagation();
                            setActiveBio(member.id);
                          }}
                        >
                          View Bio
                        </button>
                      </div>
                      <div className="ul-team-member-info">
                        <h3 className="ul-team-member-name">{member.name}</h3>
                        <p className="ul-team-member-designation">{member.position}</p>
                      </div>
                    </div>
                    <div className="ul-team-member-back">
                      <div className="ul-team-member-bio">
                        <div className="ul-team-member-bio-content">
                          <button
                            className="ul-team-member-back-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              setActiveBio(null);
                            }}
                            aria-label="Back to profile"
                          >
                            <i className="flaticon-left-arrow"></i>
                          </button>
                          <h4 className="ul-team-member-bio-name">{member.name}</h4>
                          <p className="ul-team-member-bio-position">{member.position}</p>
                          <p className="ul-team-member-bio-text">{member.bio}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-5">
            <p className="text-center" style={{
              color: 'var(--ul-p, #666)',
              fontSize: 'clamp(18px, 1.68vw, 22px)',
              lineHeight: '1.8'
            }}>
              We are actively seeking healthcare professionals (doctors,
              physician assistants, nurses, dental professionals) to serve as
              mentors and advisors.{' '}
              <Link to="/contact"
                style={{
                  color: 'var(--ul-primary)',
                  textDecoration: 'underline',
                  marginLeft: '8px',
                  fontWeight: '600'
                }}
              >Contact us</Link>
              {' '}if you're interested in supporting our mission.
            </p>
          </div>
        </div>
      </section>

    </main>

      <Footer />
    </>
  );
};

export default Team;
